var exports = {
  "kL": "MemberListStyles.module__container___SEZfbG",
  "wx": "MemberListStyles.module__header___SEZfbG",
  "DD": "MemberListStyles.module__title___SEZfbG",
  "VA": "MemberListStyles.module__subtitle___SEZfbG",
  "Rt": "MemberListStyles.module__searchInput___SEZfbG",
  "ne": "MemberListStyles.module__controls___SEZfbG",
  "jG": "MemberListStyles.module__scrollContainer___SEZfbG",
  "JD": "MemberListStyles.module__memberList___SEZfbG",
  "yj": "MemberListStyles.module__memberGroup___SEZfbG",
  "zc": "MemberListStyles.module__memberItemWrapper___SEZfbG",
  "Ku": "MemberListStyles.module__memberItem___SEZfbG",
  "S6": "MemberListStyles.module__memberItemInteractive___SEZfbG",
  "Kx": "MemberListStyles.module__memberItemPressed___SEZfbG",
  "Iw": "MemberListStyles.module__memberMain___SEZfbG",
  "R3": "MemberListStyles.module__avatarWrapper___SEZfbG",
  "my": "MemberListStyles.module__avatar___SEZfbG",
  "rZ": "MemberListStyles.module__avatarPlaceholder___SEZfbG",
  "Fj": "MemberListStyles.module__memberInfo___SEZfbG",
  "S7": "MemberListStyles.module__nameRow___SEZfbG",
  "QC": "MemberListStyles.module__displayName___SEZfbG",
  "Tc": "MemberListStyles.module__tag___SEZfbG",
  "_L": "MemberListStyles.module__memberActions___SEZfbG",
  "Mj": "MemberListStyles.module__moreButton___SEZfbG",
  "UM": "MemberListStyles.module__moreButtonActive___SEZfbG",
  "z5": "MemberListStyles.module__moreButtonIcon___SEZfbG",
  "ai": "MemberListStyles.module__chevron___SEZfbG",
  "yF": "MemberListStyles.module__divider___SEZfbG",
  "g4": "MemberListStyles.module__loadingContainer___SEZfbG",
  "KQ": "MemberListStyles.module__loadingText___SEZfbG",
  "lm": "MemberListStyles.module__notice___SEZfbG",
  "ut": "MemberListStyles.module__noticeText___SEZfbG",
};

module.exports = exports;
